/**
 * Close mobile menu when navigating to same-page anchors
 *
 * Problem: When clicking anchor links (like /#faq) in the mobile menu while
 * already on the homepage, the menu doesn't close because no page navigation occurs.
 *
 * Solution: Listen for hashchange events and close the header drawer if it's open.
 */
(function() {
  function closeMenuOnHashChange() {
    const headerDrawer = document.querySelector('header-drawer');
    if (!headerDrawer) return;

    const mainDetails = headerDrawer.querySelector('details[open]');
    if (mainDetails) {
      const summary = mainDetails.querySelector('summary');
      if (summary) summary.click();
    }
  }

  window.addEventListener('hashchange', closeMenuOnHashChange);

  // Theme editor support - re-attach listener when sections reload
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('header-drawer')) {
      window.removeEventListener('hashchange', closeMenuOnHashChange);
      window.addEventListener('hashchange', closeMenuOnHashChange);
    }
  });
})();
